import { combineReducers } from "redux";


const isLoggedIn = (state=null, action) => {
  switch(action.type) {
    case "LOGIN":
      return true;

    case "LOGOUT":
      return false;

    default:
      return state;
  }
};

const isLoading = (state=null, action) => {
  switch(action.type) {
    case "REGISTER_REQUEST":
    case "LOGGING_IN":
      return true;

    case "REGISTER":
    case "REGISTER_SUCCESS":
    case "REGISTER_ERROR":
    case "LOGIN":
    case "LOGOUT":
      return false;

    default:
      return state;
  }
};

const id = (state="", action) => {
  switch(action.type) {
    case 'LOGIN':
      return action.userId || action.user.id || action.user.userId;

    case 'LOGOUT':
      return "";

    default:
      return state;
  }
};

const firstName = (state="", action) => {
  switch(action.type) {
    case 'LOGIN':
    case 'UPDATE_LOGGED_IN_USER':
      return action.user.firstName;

    case 'LOGOUT':
      return "";

    default:
      return state;
  }
};

const lastName = (state="", action) => {
  switch(action.type) {
    case 'LOGIN':
    case 'UPDATE_LOGGED_IN_USER':
      return action.user.lastName;

    case 'LOGOUT':
      return "";

    default:
      return state;
  }
};

const email = (state="", action) => {
  switch(action.type) {
    case 'LOGIN':
    case 'UPDATE_LOGGED_IN_USER':
      return action.user.email;

    case 'LOGOUT':
      return "";

    default:
      return state;
  }
};

const permissions = (state={}, action) => {
  switch(action.type) {
    case 'LOGIN':
    case 'UPDATE_LOGGED_IN_USER':
      return action.user.permissions;

    case 'LOGOUT':
      return {};

    default:
      return state;
  }
};

const agencyId = (state=null, action) => {
  switch(action.type) {
    case 'LOGIN':
    case 'UPDATE_LOGGED_IN_USER':
      if(action.agencyId) {
        return action.agencyId;
      }
      if(action.user && action.user.agencyId) {
        return action.user.agencyId;
      }
      return state;

    case 'SET_AGENCY':
      return action.agencyId;

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

const agencyIds = (state=null, action) => {
  switch(action.type) {
    case 'LOGIN':
    case 'UPDATE_LOGGED_IN_USER':
      return action.user.agencyIds || null;

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

const activeTalent = (state=null, action) => {
  switch(action.type) {
    case 'LOGIN':
    case 'UPDATE_LOGGED_IN_USER':
      return action.user.activeTalent || null;

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

const activeDivision = (state=null, action) => {
  switch(action.type) {
    case 'LOGIN':
    case 'UPDATE_LOGGED_IN_USER':
      return action.user.activeDivision || null;

    case 'LOGOUT':
      return null;

    case 'SET_ACTIVE_DIVISION':
      return action.division;

    default:
      return state;
  }
};

const requireSubscription = (state=false, action) => {
  switch(action.type) {
    case 'LOGIN':
    case 'UPDATE_LOGGED_IN_USER':
      return !!action.user.requireSubscription;

    case 'LOAD_SUBSCRIPTION':
      return false;

    case 'LOGOUT':
      return false;

    default:
      return state;
  }
};

const error = (state=null, action) => {
  switch(action.type) {
    case 'REGISTER':
    case 'REGISTER_SUCCESS':
    case 'LOGIN':
      return null;

    case 'REGISTER_ERROR':
    case 'LOAD_INVITATION_FAILURE':
      return {
        code: action.code,
        message: action.message,
      };

    default:
      return state;
  }
};

const role = (state="", action) => {
  switch(action.type) {
    case 'LOGIN':
    case 'UPDATE_LOGGED_IN_USER':
      return action.user.role || 'talent';

    case 'LOGOUT':
      return "";

    default:
      return state;
  }
};

const hasAggreedToTerms = (state=false, action) => {
  switch(action.type) {
    case 'LOGIN':
    case 'UPDATE_LOGGED_IN_USER':
      return !!action.user.agreedToTerms;

    case 'AGREE_TO_TERMS':
      return action.agreedToTerms;

    case 'LOGOUT':
      return false;

    default:
      return state;
  }
};

const stripeCustomerId = (state=false, action) => {
  switch(action.type) {
    case 'LOGIN':
    case 'UPDATE_LOGGED_IN_USER':
      return action.user.stripeCustomerId || null;
    
    case 'LOGOUT':
      return false;

    default:
      return state;
  }
};




/* DEPRICATED */
const talents = (state=null, action) => {
  switch(action.type) {
    case 'LOGIN':
    case 'UPDATE_LOGGED_IN_USER':
      return action.user.talents || null;

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};




export default combineReducers({
  isLoading,
  isLoggedIn,
  id,
  firstName,
  lastName,
  email,
  permissions,
  agencyId,
  agencyIds,
  activeTalent,
  activeDivision,
  requireSubscription,
  stripeCustomerId,
  error,
  hasAggreedToTerms,
  talents,
  role,
});